(function (angular) {
	'use strict';

	var placeholderGridObject = {
		bindings: {
			numColumns: '<',
			numRows: '<',
			placehold: '<',
			theme: '<'
		},
		controller: [PlaceholderGridFunction],
		controllerAs: 'placeholderGrid',
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		transclude: true
	};

	angular
		.module('placeholderModule')
		.component('placeholderGrid', placeholderGridObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/shared/placeholder/placeholder-grid.html';
	}

	function PlaceholderGridFunction() {
		var placeholderGrid = this;

		placeholderGrid.$onInit = function() {
			placeholderGrid.numColumns = placeholderGrid.numColumns || 4;
			placeholderGrid.numRows = placeholderGrid.numRows || 3;
			placeholderGrid.theme = placeholderGrid.theme || 'light';
			placeholderGrid.numRowsArr = [];
			placeholderGrid.numColumnsArr = [];

			for(var i = 0; i < placeholderGrid.numRows; i++) {
				placeholderGrid.numRowsArr.push(i);
			}

			for(i = 0; i < placeholderGrid.numColumns; i++) {
				placeholderGrid.numColumnsArr.push(i);
			}

			updateBlockClass();
		};

		function updateBlockClass() {
			var colWidth = 12 / placeholderGrid.numColumns;
			placeholderGrid.blockClass = 'col-' + colWidth + '-md';
		}
	}

})(window.angular);